const NON_PERCENT_STATS = [
  "discriminant_power",
  "total_count",
  "youdens_index",
];

export { NON_PERCENT_STATS };
